const PHONE_REGEX = /^[0-9]{10,20}$/
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

export const validatePhone = (phone) => PHONE_REGEX.test(phone)

export const validateEmail = (email) => EMAIL_REGEX.test(email)

export const normalizePhone = (phone) => phone.replace(/[-\s]/g, '')

export const validateBirthYear = (year) => {
  const currentYear = new Date().getFullYear()
  return year >= currentYear - 80 && year <= currentYear - 18
}

export const generateBirthYearOptions = () => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - 18
  const endYear = currentYear - 63
  const options = []
  for (let y = startYear; y >= endYear; y--) {
    options.push({ value: y, label: `${y}年` })
  }
  return options
}
